import React, { Component } from "react";
import "./Header.css";
import { Fade } from "react-reveal";
import { NavLink, Link } from "react-router-dom";
import { greeting, settings } from "../../portfolio.js";
import SeoHeader from "../seoHeader/SeoHeader";
import LanguageToggle from "../languageToggle/LanguageToggle";
import { useLanguage } from "../../context/LanguageContext";
import { getTranslation } from "../../translations/translations";

const HeaderContent = ({ theme }) => {
  const { language } = useLanguage();
  const link = settings.isSplash ? "/splash" : "home";

  const menuItems = [
    { href: "#hero", label: getTranslation(language, "home") },
    { href: "#about", label: getTranslation(language, "about") },
    { href: "#leadership", label: getTranslation(language, "leadership") },
    { href: "#gallery", label: getTranslation(language, "gallery") },
    { href: "#donations", label: getTranslation(language, "donate") },
  ];

  const onMouseEnter = (event, color) => {
    event.target.style.color = color;
  };

  const onMouseOut = (event) => {
    event.target.style.color = "#FFFFFF";
  };

  return (
    <Fade top duration={1000} distance="20px">
      <SeoHeader />
      <div className="header-wrapper">
        <div className="header-wrapper-lines"></div>
        <header className="header">
          <NavLink to={link} tag={Link} className="logo-container">
            <i
              className="fas fa-church"
              style={{ fontSize: "2rem", color: "#FFFFFF" }}
            ></i>
            <span className="logo-name" style={{ color: "#FFFFFF" }}>
              {greeting.logo_name}
            </span>
          </NavLink>
          <LanguageToggle />
          <input className="menu-btn" type="checkbox" id="menu-btn" />
          <label className="menu-icon" htmlFor="menu-btn">
            <span className="navicon"></span>
          </label>
          <ul className="menu">
            {menuItems.map((item, index) => (
              <li key={index}>
                <a
                  href={item.href}
                  style={{ color: "#FFFFFF" }}
                  onMouseEnter={(event) => onMouseEnter(event, "#E0F5F0")}
                  onMouseOut={(event) => onMouseOut(event)}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </header>
      </div>
    </Fade>
  );
};

class Header extends Component {
  render() {
    return <HeaderContent theme={this.props.theme} />;
  }
}

export default Header;
